'use strict';

var colors = require('./chartsColors');

function highchartsTheme () {
  var fonts = {
    fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: '12px',
    fontWeight: 400
  };
  var theme = {
    colors: [
      colors.primaryDarker,
      colors.success,
      colors.warning,
      colors.error,
      colors.greyDark
    ],
    chart: {
      backgroundColor: null,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      animation: false,
      style: {
        fontFamily: fonts.fontFamily,
        fontSize: fonts.fontSize,
        color: colors.greyDarker
      }
    },
    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    tooltip: {
      enabled: false,
      style: {
        fontFamily: fonts.fontFamily,
        fontSize: fonts.fontSize,
        color: colors.greyDarker
      }
    },
    xAxis: {
      enabled: false,
      gridLineColor: colors.greySmoke,
      labels: {
        style: {
          fontFamily: fonts.fontFamily,
          fontSize: fonts.fontSize,
          color: colors.greyMedium
        }
      },
      title: {
        style: {
          fontFamily: fonts.fontFamily,
          fontSize: fonts.fontSize,
          color: colors.greyMedium
        }
      }
    },
    yAxis: {
      gridLineColor: colors.greySmoke,
      labels: {
        style: {
          fontFamily: fonts.fontFamily,
          fontSize: fonts.fontSize,
          color: colors.greyMedium
        }
      },
      title: {
        text: null,
        style: {
          fontFamily: fonts.fontFamily,
          fontSize: fonts.fontSize,
          color: colors.greyMedium
        }
      }
    },
    legend: {
      borderWidth: null,
      itemStyle: {
        fontFamily: fonts.fontFamily,
        fontSize: fonts.fontSize,
        fontWeight: fonts.fontWeight,
        color: colors.greyDark
      },
      itemHoverStyle: {
        color: colors.greyDarker
      },
      itemHiddenStyle: {
        color: colors.greyMedium
      }
    },
    labels: {
      style: {
        color: colors.greyMedium
      }
    }
  };

  return theme;
}

module.exports = highchartsTheme;
